


















import CommonBase from "@/components/CommonBase";
import {Component} from "vue-property-decorator";

@Component
export default class LocationInfoText extends CommonBase{
}
